import { useQuery } from "@tanstack/react-query";
import { fetchDesktopUninstalls } from "../api/uninstallsApi";

export const uninstallsKeys = {
  all: ["desktop-uninstalls"] as const,
};

export const useDesktopUninstallsQuery = () =>
  useQuery({
    queryKey: uninstallsKeys.all,
    queryFn: () => fetchDesktopUninstalls(),
    refetchInterval: 60_000,
  });
